import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import LogReportLayer from "../components/LogReportLayer";

const LogReportPage = () => {
    return (
        <MasterLayout>
            <LogReportLayer />
        </MasterLayout>
    );
};

export default LogReportPage;
